/* 店铺 */
import Information from "../pages/shop/pages/infomation/information"; //店铺基本信息
import PayConfigure from "../pages/shop/pages/infomation/payConfigure"; //店铺基本信息

import WxPayInfo from "../pages/shop/pages/infomation/wxPayInfo"; //店铺基本信息
import Peopleinfo from "../pages/shop/pages/set/peopleinfo"; //用户授权
import shopPermission from "../pages/shop/pages/set/shoppermission"; //所有权限
// import Shopinfo from '../pages/shop/set/shopinfo'//
import CreateCoupons from "../pages/shop/pages/vip/ticket/createCoupons"; //
import CouponForm from "../pages/shop/pages/vip/ticket/couponForm"; // 创建卷
import CouponList from '../pages/shop/pages/vip/ticket/couponList'; //卷列表
import CreateActive from "../pages/shop/pages/vip/createActive"; //
import SetVipPermission from "../pages/shop/pages/vip/setVipPermission"; // 电子会员请求
import AllVip from "../pages/shop/pages/vip/allvip"; //所有会员
import Welcome from "../pages/welcome"; //欢迎页
import Payment from '../pages/shop/pages/supplier/payment.vue';
import ReturnGoods from '../pages/shop/pages/supplier/returnGoods.vue';
import SaleBottom from '../pages/shop/pages/supplier/saleBottom.vue';
import SaleTop from '../pages/shop/pages/supplier/saleTop.vue';
import SupGoodsInfo from "../pages/shop/pages/supplier/supGoodsInfo.vue";
import GoodsApply from "../pages/shop/pages/supplier/goodsApply.vue";
import tigerzzVideo from "../pages/tigerzzVideo.vue"; //泰格视频
// import ShopHome from "../pages/shop/pages/shopHome";
import CreateCardClass from "../pages/shop/pages/vip/createCardClass"; //创建卡类别
import DrawTemplate from "../pages/shop/pages/platform/drawtemplate"; //标价签模板
import InSheet from "../pages/shop/pages/warehouse/insheet"; //入库
import OutSheet from "../pages/shop/pages/warehouse/outsheet"; //出库
import Business from "../pages/shop/pages/business/business"; //
import MUserGroup from "../pages/shop/pages/set/muserGroup"; //用户组

import ReportWare from "../pages/people/pages/warehouse/reportware";
import Classinfo from "../pages/shop/pages/baseinfo/classInfo";
import Supplier from "../pages/shop/pages/baseinfo/supplier";
import CreateContract from "../pages/people/pages/cooperate/createContract";
import Collection from "../pages/people/pages/cooperate/collection";

/* onlineStore 线上商城*/
import ClassGenerate from "../pages/shop/pages/onlineStore/pages/classGenerate.vue";
import GoodsUpload from "../pages/shop/pages/onlineStore/pages/goods/goodsUpload.vue";
import Logistics from "../pages/shop/pages/onlineStore/pages/logistics/logistics.vue";
import LogisticsList from "../pages/shop/pages/onlineStore/pages/logistics/logisticsList.vue";
import GoodsList from '../pages/shop/pages/onlineStore/pages/goods/goodsList.vue';
import WebView from '../pages/shop/pages/onlineStore/pages/webView/index.vue';
import Renovation from '../pages/shop/pages/onlineStore/pages/renovation/renovation.vue';
import Order from '../pages/shop/pages/onlineStore/pages/order/order.vue';
import CustomerService from '../pages/shop/pages/onlineStore/pages/customerService/customerService.vue';
import ChatMessage from '../pages/shop/pages/onlineStore/pages/customerService/chatMessage.vue'

/* 基本信息 */
export default [
  { path: "/welcome", name: "welcome", component: Welcome },
  { path: "/peopleinfo", name: "peopleinfo", component: Peopleinfo },
  { path: "/shoppermission", name: "shoppermission", component: shopPermission },
  { path: "/musergroup", name: "usergroup", component: MUserGroup },
  // { path: '/shopinfo', name: 'shopinfo', component: Shopinfo },
  { path: "/information", name: "information", component: Information },
  { path: "/payConfigure", name: "payConfigure", component: PayConfigure },
  { path: "/wxPayInfo", name: "wxPayInfo", component: WxPayInfo },
  { path: "/payment", name: "payment", component: Payment },
  { path: "/returnGoods", name: "returnGoods", component: ReturnGoods },
  { path: "/goodsApply", name: "goodsApply", component: GoodsApply },

  { path: "/saleBottom", name: "saleBottom", component: SaleBottom },
  { path: "/saleTop", name: "saleTop", component: SaleTop },
  {
    path: "/tigerzzvideo",
    name: "tigerzzvideo",
    component: tigerzzVideo
  },

  {
    path: "/createCoupons",
    name: "createCoupons",
    component: CreateCoupons
  },
  {
    path: "/couponForm",
    name: "couponForm",
    component: CouponForm
  },
  {
    path: "/couponList",
    name: "couponList",
    component: CouponList
  },
  {
    path: "/CreateActive",
    name: "CreateActive",
    component: CreateActive
  },
  {
    path: "/setVipPermission",
    name: "setVipPermission",
    component: SetVipPermission
  },
  {
    path: "/supGoodsInfo",
    name: "supGoodsInfo",
    component: SupGoodsInfo
  },
  {
    path: "/CreateCardClass",
    name: "CreateCardClass",
    component: CreateCardClass
  },
  { path: "/business", name: "business", component: Business },
  { path: "/insheet", name: "insheet", component: InSheet },
  { path: "/outsheet", name: "outsheet", component: OutSheet },
  {
    path: "/drawtemplate",
    name: "drawtemplate",
    component: DrawTemplate
  },
  { path: "/allvip", name: "allvip", component: AllVip },
  { path: "/reportware", name: "reportware", component: ReportWare },

  { path: "/classInfo", name: "classInfo", component: Classinfo },
  { path: "/supplier", name: "supplier", component: Supplier },

  {
    path: "/createContract",
    name: "createContract",
    component: CreateContract
  },
  { path: "/collection", name: "collection", component: Collection },

  /* 线上商城 */
  /* 基本信息 */
  { path: "/classGenerate", name: "classGenerate", component: ClassGenerate },
  { path: "/goodsUpload", name: "goodsUpload", component: GoodsUpload },
  { path: "/logistics", name: "logistics", component: Logistics },
  { path: "/logisticsList", name: "logisticsList", component: LogisticsList },
  { path: "/goodsList", name: "goodsList", component: GoodsList },
  { path: "/renovation", name: "renovation", component: Renovation },
  /* 订单信息 */
  { path: "/order", name: "order", component: Order },
  { path: "/customerService", name: "customerService", component: CustomerService },
  { path: "/chatMessage", name: "chatMessage", component: ChatMessage },
  { path: "/webView", name: "webView", component: WebView }

]